// extracted by mini-css-extract-plugin
export default {"fontHeading":"GHe5LkMkmj8o4_TyOyOj","icon":"zJrRPwm7itTNftcvuYDW"};